export class RequisitionError extends Error {
  constructor(errorMessage) {
    super(errorMessage);
    this.name = "RequisitionError";
  }
}
